import React from 'react'
import { connect } from 'react-redux'
import { createSelector, createStructuredSelector } from 'reselect'
import uniq from 'lodash/uniq'
import Why from '../components/Why'
import AppLinks from '../components/AppLinks'
import MobileRadioBlock from '../components/MobileRadioBlock'
import Subscription from '../components/Subscription'
import SubscriptionPurchaseOptions from '../components/SubscriptionPurchaseOptions'
import NotLoseSubscribtion from '../components/NotLoseSubscribtion'
import { profileSelector } from '../reducers/profile'
import { SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT } from '../constants/ProductsNew'

const BLANK_ARRAY = []
const subscriptionsSelector = createSelector([profileSelector], profile => profile.subscriptions || BLANK_ARRAY)

function SubscriptionTab({ subscriptions }) {
  const activeAppleSubscriptionTypes = uniq(
    subscriptions
      .filter(s => s.kind === 'apple_subscription')
      .map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product])
  )
  const activeGoogleSubscriptionTypes = uniq(
    subscriptions
      .filter(s => s.kind === 'google_subscription')
      .map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product])
  )

  const activeWebSubscriptionTypes = uniq(
    subscriptions
      .filter(s => s.kind === 'web_subscription')
      .map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product])
  )

  const allSubscriptionTypes = uniq(subscriptions.map(s => SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product]))
  // скрываем блок с покупкой веб-подписки если уже все виды подписок есть
  const purchaseOptionsIsActive =
    activeWebSubscriptionTypes.includes('pack') &&
    activeWebSubscriptionTypes.includes('radio') &&
    activeWebSubscriptionTypes.includes('kids')

  // скрываем блок если куплена Р+Г навсегда
  const foreverPack = subscriptions.find(s => s.product === 'pack_lifetime')

  return (
    <>
      <NotLoseSubscribtion />
      <Why />
      {subscriptions.map((s, index) => (
        <Subscription {...s} key={index} index={index} type={SUBSCRIPTION_PRODUCT_NEW_TYPES_BY_PRODUCT[s.product]} />
      ))}
      {!purchaseOptionsIsActive && !foreverPack && (
        <SubscriptionPurchaseOptions
          activeAppleSubscriptionTypes={activeAppleSubscriptionTypes}
          activeGoogleSubscriptionTypes={activeGoogleSubscriptionTypes}
          activeWebSubscriptionTypes={activeWebSubscriptionTypes}
          subscriptionTypes={allSubscriptionTypes}
        />
      )}
      <AppLinks />
      <MobileRadioBlock />
    </>
  )
}

const mapStateToProps = createStructuredSelector({
  profile: profileSelector,
  subscriptions: subscriptionsSelector
})

export default connect(mapStateToProps)(SubscriptionTab)
